<template>
  <th
      :class="['sortable', columnName === sortColumn ? 'sorted' : '', extraClasses]"
      scope="col" @click="sortFunction(columnName)">
    <span>{{ text }}</span>
    <ChevronDownIcon v-if="sortColumn === columnName && sortDirectionAscending"/>
    <ChevronUpIcon v-if="sortColumn === columnName && !sortDirectionAscending"/>
  </th>
</template>

<script>

import ChevronDownIcon from "@/components/tables/icons/ChevronDown";
import ChevronUpIcon from "@/components/tables/icons/ChevronUp";

export default {
  name: "SortableTableHeaderComponent",
  components: {
    ChevronUpIcon,
    ChevronDownIcon
  },
  props: ["columnName", "sortColumn", "sortDirectionAscending", "text", "sortFunction", "extraClasses"],
};
</script>

<style scoped>

.sortable:hover {
  cursor: pointer;
  text-decoration: underline;
}

.sorted {
  text-decoration: underline;
}

th {

}
</style>
